__turbopack_context__.v({
  "body": "sKw5jq_body",
  "card": "sKw5jq_card",
  "copy": "sKw5jq_copy",
  "linkRow": "sKw5jq_linkRow",
  "media": "sKw5jq_media",
  "mediaShimmer": "sKw5jq_mediaShimmer",
  "title": "sKw5jq_title",
});
